import { assertEvent, fromPromise, setup } from 'xstate5'
import {
  assertFriendlyError,
  type FriendlyError,
} from '@/functional/friendlyErrors'
import { type Emits as EmitsSettingsRequestPure } from './PmSettingsRequestPure.vue'

export const PmSettingsRequestState = setup({
  types: {
    events: {} as {
      type: 'save'
      variables: EmitsSettingsRequestPure['submit'][0]
    },

    context: {} as {
      error: FriendlyError | undefined
    },
  },

  actions: {
    showSuccessNotification: () => {
      throw new Error('showSuccessNotification not implemented')
    },
  },

  actors: {
    save: fromPromise<
      void,
      { variables: EmitsSettingsRequestPure['submit'][0] }
    >(async () => {
      throw new Error('save not implemented')
    }),
  },
}).createMachine({
  id: 'PmSettingsRequestState',
  initial: 'default',

  context: {
    error: undefined,
  },

  states: {
    default: {
      on: {
        save: 'save',
      },
    },

    save: {
      initial: 'saving',

      states: {
        saving: {
          invoke: {
            id: 'save',
            src: 'save',
            input: ({ event }) => {
              assertEvent(event, 'save')
              return { variables: event.variables }
            },
            onDone: {
              target: 'success',
            },
            onError: {
              target: 'error',
              actions: ({ context, event }) => {
                assertFriendlyError(event.error)
                context.error = event.error.errors
              },
            },
          },
        },

        success: {
          entry: 'showSuccessNotification',
          always: '#PmSettingsRequestState.default',
        },

        error: {},
      },
    },
  },
})
